import { cn } from "@au-schein-de/au-ui-library";
import { cva } from "class-variance-authority";
import { PriceComparisonDiscountBadge } from "~/features/price-comparison/price-comparison-discount-badge.component";
import type { PriceComparisonDiscount } from "~/features/price-comparison/price-comparison-discounts";
import { PriceComparisonOldPrice } from "~/features/price-comparison/price-comparison-old-price.component";

const priceComparisonVariant = cva("w-full flex flex-row gap-1", {
	variants: {
		variant: {
			selected: "border-[2px] border-ansay-main outline-ansay-main",
			normal: "border-[2px] border-transparent outline-ansay-main",
		},
	},
	defaultVariants: {
		variant: "normal",
	},
});

export function PriceComparison({
	priceComparisonDiscount,
	category,
	kind,
	className,
}: {
	priceComparisonDiscount?: PriceComparisonDiscount;
	category: string | null;
	kind?: string | null;
	className?: string;
}) {
	if (!priceComparisonDiscount || !priceComparisonDiscount?.visible) {
		return null;
	}

	return (
		<div className={cn("w-full flex flex-row gap-1", className)}>
			<PriceComparisonOldPrice
				priceComparisonDiscount={priceComparisonDiscount}
				productCategory={category}
				productKind={kind}
			/>
			<PriceComparisonDiscountBadge
				discountPercentage={priceComparisonDiscount.discountPercentage}
			/>
		</div>
	);
}
